import { render, staticRenderFns } from "./RateCosts.vue?vue&type=template&id=454671ec&"
import script from "./RateCosts.vue?vue&type=script&lang=js&"
export * from "./RateCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports